import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { addSubjectFunc, getSubjectFunc, deleteSubjectFunc, updateSubjectFunc} from '../action/emailSettingAction';
import EmailSubjectComponent from '../components/emailSubjectComponent';

export class EmailSubjectContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getSubjectFunc();
    }
    getSubjectData = () =>{
        this.props.actions.getSubjectFunc(
            this.props.dispatch
        )
    }
    
    addSubject = (payload) =>{
        this.props.actions.addSubjectFunc(
            payload,
            this.props.dispatch
        )
    }
    updateSubject = (payload) =>{
        this.props.actions.updateSubjectFunc(
            payload,
            this.props.dispatch
        )
    }
    deleteSubject = (payload) => {
        this.props.actions.deleteSubjectFunc(
            payload,
            this.props.dispatch
        )
    }
    render(){
        return(
            // <EmailSettingComponent
            //     getAllEmailSettingData = {this.props.emailSettingData}
            //     updateRejection = {this.applicationRejection}
            //     updateApproval = {this.approvalTime}
            //     updateForgotPswd = {this.forgotPassword}
            //     updateRegistration = {this.registrationTime}
            //     allEmailSetting = {this.allEmailSetting}
            // >    
            // </EmailSettingComponent>
            <EmailSubjectComponent
                getAllEmailSettingData = {this.props.emailSettingData}
                addSubject = {this.addSubject}
                getSubjectData = {this.getSubjectData}
                deleteSubject = {this.deleteSubject}
                updateSubject = {this.updateSubject}
            >
            </EmailSubjectComponent>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            addSubjectFunc,
            getSubjectFunc,
            deleteSubjectFunc,
            updateSubjectFunc
        },
            dispatch)
    };
}
function mapStateToProps({ EmailSettingReducer }) {
    console.log(EmailSettingReducer);
    return {
        emailSettingData : {
            errorCode : EmailSettingReducer.errorCode,
            statusCode : EmailSettingReducer.statusCode,
            // emailSettingList : EmailSettingReducer.emailSettingList,
            // updatedEmailSetting : EmailSettingReducer.updatedEmailSetting,
            Message : EmailSettingReducer.Message,
            SubjectList : EmailSettingReducer.SubjectList,
            isLoading : EmailSettingReducer.isLoading,
            // SMTPdetail : {}
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmailSubjectContainer));
